import { ReactNode } from "react";
import { WritableAtom } from "jotai";
import { useHydrateAtoms } from "jotai/utils";

type HydrateAtomsProps = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    atomValues: Iterable<readonly [WritableAtom<unknown, [any], unknown>, unknown]>;
    children: ReactNode;
};

// https://jotai.org/docs/guides/initialize-atom-on-render
export const AtomsHydrator = ({ atomValues, children }: HydrateAtomsProps) => {
    useHydrateAtoms(new Map(atomValues));
    return children;
};
